import getValuesArray from '@/utils/array/getValuesArray'

export function prepareFormDataIdArray (data, keyStringArray) {
  const prepareFormData = {
    ...data
  }

  for (const key of keyStringArray) {
    if (key in prepareFormData) {
      prepareFormData[key] = getValuesArray(data[key])
    }
  }

  return prepareFormData
}
